import { computeOperationRow } from "../../services/common";
import { showsBatchTypeForRow } from "../../services/batchType";

const MAX_COMPOSITION_ENTRIES = 2;

// Variety on the first line, origin (and year) smaller and muted below it; "+N" for the entries not shown.
export const CompositionCell = ({ parts }) => {
  if (parts.length === 0) return "—";
  const shown = parts.slice(0, MAX_COMPOSITION_ENTRIES);
  const hidden = parts.length - shown.length;
  return (
    <>
      {shown.map(({ variety, origin, year }) => (
        <span key={`${variety}|${origin}|${year}`} className="data_cell_group">
          <span className="data_cell_main">{variety}</span>
          {(origin || year) && (
            <span className="data_cell_sub">
              {[origin, year].filter(Boolean).join(" · ")}
            </span>
          )}
        </span>
      ))}
      {hidden > 0 && <span className="data_cell_sub">{`+${hidden}`}</span>}
    </>
  );
};

// "Phase · substate" on the first line, with the dot when an operation is running on the lot (started, not
// completed); below, in muted text, "In progress" and which operation, or that the lot is only planned.
// Tanks whose substates differ get one line each.
export const PhaseCell = ({
  lot,
  getLabel,
  onlyConfirmed,
  running,
  treatments,
  analysis,
}) => {
  const inProgress = running.length > 0;
  const mixed = lot.has_mixed_substates && lot.tank_substates?.length > 0;
  // A lot-like without a state is an empty container (the tanks list uses this cell too).
  const phase = lot.state
    ? `${getLabel(`lotState_${lot.state}`)}${showsBatchTypeForRow(lot) ? ` (${getLabel(`lotType${lot.batch_type}`)?.toLowerCase()})` : ""}`
    : getLabel("tankState_EMPTY");
  const substate =
    !mixed && lot.substate ? getLabel(`lotSubstate_${lot.substate}`) : "";
  return (
    <>
      <span className="data_cell_main lot_phase">
        {inProgress && (
          <span
            className="data_dot"
            role="img"
            aria-label={getLabel("homeOpStatusInProgress")}
          />
        )}
        {substate ? `${phase} · ${substate}` : phase}
      </span>
      {mixed &&
        lot.tank_substates
          .filter((ts) => ts?.substate)
          .map((ts, index) => (
            <span key={`${ts.tank_id ?? index}`} className="data_cell_sub">
              {`${ts.tank_name}: ${getLabel(`lotSubstate_${ts.substate}`)}`}
            </span>
          ))}
      {inProgress ? (
        <span className="data_cell_sub">
          {[
            getLabel("homeOpStatusInProgress"),
            ...running.map((operation) =>
              computeOperationRow(operation, treatments, analysis, getLabel),
            ),
          ].join(" · ")}
        </span>
      ) : (
        lot.status === "PLANNED" &&
        !onlyConfirmed && (
          <span className="data_cell_sub">{getLabel("lotStatus_PLANNED")}</span>
        )
      )}
    </>
  );
};

export const tankNames = (lot) =>
  (lot?.tanks || [])
    .map((tank) => tank?.tank_name || tank?.name)
    .filter(Boolean);
